module.exports = __webpack_public_path__ + "img/en_con.504f00a3.png";